export function getDeviceInfo() {
  return {
    vendor: navigator.vendor,
    userAgent: navigator.userAgent,
    doNotTrack: navigator.doNotTrack,
    deviceMemory: navigator.deviceMemory,
    cookieEnabled: navigator.cookieEnabled,
  };
}
